
import { SpinnerService } from './spinner.service';
import { Component } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: []
})
export class SpinnerComponent {
  showSpinner = this.spinnerService.showSpinner;

  constructor(private spinnerService: SpinnerService) { }
}
